import ChainLogo from 'features/NewHotelDialog/ChainLogo'

import styles from '../../NewHotel.module.scss'

const NewHotelHeader = ({ formData, brand, setBrand, chainName }) => {
  const { streetAddress, city, stateCode, hotelName, parentChainCode } = formData

  return (
    <div className={styles.header}>
      {parentChainCode && parentChainCode !== 'independent' && (
        <ChainLogo
          className={styles.chainLogo}
          parentChainCode={parentChainCode}
          brand={brand}
          setBrand={setBrand}
          chainCode={chainName}
        />
      )}
      <div className={styles.headerText}>
        <div className={styles.headerTitle}>{hotelName}</div>
        <div className={styles.headerSubtitle}>
          {[streetAddress, city, stateCode].filter(Boolean).join(', ')}
        </div>
      </div>
    </div>
  )
}

export default NewHotelHeader
